import { StatusPillEnum } from '../../components/status-pill/status-pill.component';
import { RolesEnum } from '../../models/enums/roles.enum';
import { User } from '../../models/interfaces/user.interface';

const tenantId = 'tenant-uuid';
const tenantName = 'Unico Tenant';

export const tenantTestUser = {
  id: 'user-uuid',
  name: 'Teste Usuário',
  email: 'unico-tenant@unico.com',
  password: '123456',
  role: RolesEnum.admin,
};

export const userMock: User = {
  id: tenantTestUser.id,
  tenantId,
  tenantName,
  email: tenantTestUser.email,
  name: tenantTestUser.name,
  role: RolesEnum.admin,
  roles: ['admin:*'],
  context: 'admin',
  status: StatusPillEnum.ACTIVE,
  sector: 'Marketing',
  position: 'Gerente de Marketing',
  createdAt: new Date(),
  updatedAt: new Date(),
  isActive: true,
};

export function isValidMockCredentials(email: string | null, password: string | null): boolean {
  return email?.trim().toLowerCase() === tenantTestUser.email.toLowerCase()
    && password === tenantTestUser.password;
}

export const users: User[] = [
  {
    id: '1',
    tenantId,
    tenantName,
    name: 'Alice Brown',
    email: 'alice.brown@example.com',
    role: RolesEnum.admin,
    roles: ['admin:*'],
    context: 'admin',
    status: StatusPillEnum.ACTIVE,
    sector: 'Marketing',
    position: 'Gerente de Marketing',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '2',
    tenantId,
    tenantName,
    name: 'John Doe',
    email: 'john.doe@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.PENDING,
    sector: 'Desenvolvimento',
    position: 'Desenvolvedor Senior',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '3',
    tenantId,
    tenantName,
    name: 'Emma Miller',
    email: 'emma.miller@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Vendas',
    position: 'Coordenadora de Vendas',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '4',
    tenantId,
    tenantName,
    name: 'Lucas Taylor',
    email: 'lucas.taylor@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.EXPIRED,
    sector: 'Recursos Humanos',
    position: 'Especialista em Recrutamento',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '5',
    tenantId,
    tenantName,
    name: 'Sophia Martinez',
    email: 'sophia.martinez@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Financas',
    position: 'Analista Financeiro',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '6',
    tenantId,
    tenantName,
    name: 'Ryana Kim',
    email: 'ryana.kim@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.INACTIVE,
    sector: 'TI',
    position: 'Engenheiro de Software',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '7',
    tenantId,
    tenantName,
    name: 'Mia Davis',
    email: 'mia.davis@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Design',
    position: 'Designer Grafico',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '8',
    tenantId,
    tenantName,
    name: 'Paul Brown',
    email: 'paul.brown@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Operacoes',
    position: 'Gerente de Operacoes',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '9',
    tenantId,
    tenantName,
    name: 'Jack White',
    email: 'jack.white@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.PENDING,
    sector: 'Suporte',
    position: 'Analista de Suporte',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '10',
    tenantId,
    tenantName,
    name: 'Zoe Turner',
    email: 'zoe.turner@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Pesquisa',
    position: 'Cientista de Dados',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '11',
    tenantId,
    tenantName,
    name: 'Henry Davis',
    email: 'henry.davis@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Logistica',
    position: 'Coordenador de Logistica',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '12',
    tenantId,
    tenantName,
    name: 'Olivia Clark',
    email: 'olivia.clark@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Compliance',
    position: 'Analista de Compliance',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '13',
    tenantId,
    tenantName,
    name: 'Noah Silva',
    email: 'noah.silva@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Produto',
    position: 'Product Manager',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '14',
    tenantId,
    tenantName,
    name: 'Laura Santos',
    email: 'laura.santos@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.PENDING,
    sector: 'Atendimento',
    position: 'Analista de Atendimento',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '15',
    tenantId,
    tenantName,
    name: 'Gabriel Rocha',
    email: 'gabriel.rocha@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.INACTIVE,
    sector: 'Operacoes',
    position: 'Supervisor Operacional',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: false,
  },
  {
    id: '16',
    tenantId,
    tenantName,
    name: 'Helena Costa',
    email: 'helena.costa@example.com',
    role: RolesEnum.admin,
    roles: ['admin:*'],
    context: 'admin',
    status: StatusPillEnum.ACTIVE,
    sector: 'Administrativo',
    position: 'Coordenadora Administrativa',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '17',
    tenantId,
    tenantName,
    name: 'Pedro Nunes',
    email: 'pedro.nunes@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.EXPIRED,
    sector: 'Jurídico',
    position: 'Assistente Juridico',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: false,
  },
  {
    id: '18',
    tenantId,
    tenantName,
    name: 'Camila Freitas',
    email: 'camila.freitas@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Comercial',
    position: 'Executiva de Contas',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '19',
    tenantId,
    tenantName,
    name: 'Rafael Gomes',
    email: 'rafael.gomes@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.PENDING,
    sector: 'Financeiro',
    position: 'Analista de Custos',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '20',
    tenantId,
    tenantName,
    name: 'Isabela Moreira',
    email: 'isabela.moreira@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Qualidade',
    position: 'Especialista de Qualidade',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '21',
    tenantId,
    tenantName,
    name: 'Bruno Almeida',
    email: 'bruno.almeida@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.INACTIVE,
    sector: 'Infraestrutura',
    position: 'Analista de Infraestrutura',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: false,
  },
  {
    id: '22',
    tenantId,
    tenantName,
    name: 'Juliana Ribeiro',
    email: 'juliana.ribeiro@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Treinamento',
    position: 'Instrutora Corporativa',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '23',
    tenantId,
    tenantName,
    name: 'Thiago Araujo',
    email: 'thiago.araujo@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.EXPIRED,
    sector: 'Seguranca',
    position: 'Analista de Seguranca',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: false,
  },
  {
    id: '24',
    tenantId,
    tenantName,
    name: 'Fernanda Lima',
    email: 'fernanda.lima@example.com',
    role: RolesEnum.user,
    roles: ['app:*'],
    context: 'app',
    status: StatusPillEnum.ACTIVE,
    sector: 'Planejamento',
    position: 'Analista de Planejamento',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
];
